import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Mobile' })({
    root: {
        boxSizing: 'border-box'
    },
    cards: {
        display: 'flex',
        gap: 8,
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: 320,
        boxSizing: 'border-box',
        padding: 16,
        borderRadius: 24,
        background: 'rgba(255, 255, 255, 0.03)',
        backdropFilter: 'blur(50px)'
    },
    summary: {
        marginBottom: 12
    },
    property: {
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        whiteSpace: 'nowrap'
    },
    caption: {
        display: 'block',
        textAlign: 'center',
        color: '#FFF',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
        opacity: 0.5,
        marginTop: 24
    }
});
